module.exports = __webpack_public_path__ + "img/cart.34d49e39.svg";